import { useEffect, useState } from "react";
import { useLocation, matchPath } from "react-router-dom";

const useIdleTimer = (timeout, onIdle) => {
  const [isIdle, setIsIdle] = useState(false);
  const location = useLocation();
  const excludedRoutes = [
    "/meeting",
    "/meetingv2",
    "/meetingmini",
    "/meetingo3mini",
    "/meeting-trsln",
    "/meeting-trspt",
    "/meeting/:meetingid",
    "/meeting/:appointmentid/:meetingid",
    "/meeting-trsln/:appointmentid/:meetingid",
    "/meeting-trspt/:appointmentid/:meetingid",
    "/meetingmini/:meetingid",
    "/meetingo3mini/:meetingid",
    "/meetingv2/:meetingid",
    "/patient/starpilot",
    "/doctor/starpilot"
  ];

  const isExcludedRoute = excludedRoutes.some((route) =>
    matchPath({ path: route, end: true }, location.pathname)
  );

  useEffect(() => {
    if (isExcludedRoute) return;

    let timer;

    const resetTimer = () => {
      if (timer) {
        clearTimeout(timer);
      }
      setIsIdle(false);
      timer = setTimeout(() => {
        setIsIdle(true);
        onIdle();
      }, timeout);
    };

    resetTimer();

    const eventListeners = [
      "mousemove",
      "keydown",
      "click",
      "touchstart",
      "scroll",
    ];
 
    eventListeners.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    return () => {
      eventListeners.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      clearTimeout(timer);
    };
  }, [timeout, onIdle]);

  return isIdle;
};

export default useIdleTimer;
